import { initTooltip } from "../../client/js/utils/Tooltip.ts";

// initPSTooltip :: Selector -> Effect Unit
export function initPSTooltip(selector) {
  return function () {
    setTimeout(function () {
      initTooltip(selector);
    }, 0);
  };
}
